import { combineReducers, configureStore } from '@reduxjs/toolkit';
import * as user from './Reducers/UserReducer';
import * as transaction from './Reducers/TransactionReducer';
import * as grp from './Reducers/GroupsReducer';
import * as grpPerm from './Reducers/GroupPermissionReducer';
import * as perm from './Reducers/PermissionsReducer';
import * as userPerm from "./Reducers/UserPermissionReducer";
import * as files from './Reducers/FileReducer';
import * as accounts from './Reducers/AdminAccountsReducer';
import * as audit from './Reducers/AuditReducer';
import * as esolutionsSmsAccount from "./Reducers/ESolutionsSmsAccountReducer";
import * as emailPackage from "./Reducers/EmailPackageReducer";
import * as smsPackage from "./Reducers/SmsPackageReducer";
import * as subscriptions from "./Reducers/SubscriptionsReducer";
import * as openPackages from "./Reducers/OpenPackagesReducer";
import * as payments from "./Reducers/PaymentsReducer";
import * as applications from "./Reducers/ApplicationsReducer";
import * as sms from "./Reducers/SmsReducer";
import * as mailingList from "./Reducers/MailingListReducer";
import * as email from './Reducers/EmailReducer';
import * as trials from './Reducers/Trialsubscriptionsreducer';

const rootReducer = combineReducers({
  // user reducers

  userProfile: user.ViewUserProfileReducer,
  userLogin: user.LoginReducer,
  updateProfile: user.UpdateProfileReducer,
  changePassword: user.ChangePasswordReducer,
  deleteAccount: user.DeleteAccountReducer,
  deleteAllUsers: user.deleteAllUsersReducer,
  deleteUser: user.DeleteAccountReducer,
  enableOrDisableTwoFactor: user.EnableOrDisableTwoFactorReducer,
  getAllUsers: user.GetAllUsersReducer,
  updateUser: user.UpdateUserReducer,
  resetUserPassword: user.ResetUserPasswordReducer,
  verifyAccount: user.VerifyAccountReducer,
  registerUser: user.CreateUserReducer,
  resendVerification: user.ResendVerificationReducer,
  twoFactorAuth: user.twoFactorAuthReducer,
  userAccount: user.ViewUserDetailsReducer,
  myBusiness: user.MyBusinessReducer,
  changeUserGroup: user.ChangeUserGroupReducer,
  changeUserStatus: user.changeUserStatusReducer,

  // groups
  getAllGroups: grp.GetAllGroupsReducer,
  getUnpagedGroups: grp.GetUnpagedGroupsReducer,
  getGroupById: grp.GetGroupByIdReducer,
  createGroup: grp.CreateGroupReducer,
  updateGroup: grp.UpdateGroupReducer,
  deleteGroup: grp.DeleteGroupReducer,

  // group permissions
  getGroupPermissions: grpPerm.GetGroupPermissionsReducer,
  getAllGroupPermissions: grpPerm.GetAllGroupPermissionsReducer,
  createGroupPermission: grpPerm.CreateGroupPermissionReducer,
  createBulkGroupPermissions: grpPerm.CreateBulkGroupPermissionsReducer,
  revokeGroupPermission: grpPerm.RevokeGroupPermissionReducer,
  revokeBulkGroupPermissions: grpPerm.RevokeBulkGroupPermissionsReducer,
  getUnassignedPermissions: grpPerm.GetUnassignedPermissionsReducer,

  // permissions
  getPermissions: perm.GetPermissionsReducer,
  getAllPermissions: perm.GetAllPermissionsReducer,
  getPermissionById: perm.GetPermissionByIdReducer,
  createPermission: perm.CreatePermissionReducer,
  createBulkPermissions: perm.CreateBulkPermissionsReducer,
  updatePermission: perm.UpdatePermissionReducer,
  getClientAccessiblePermissions: perm.GetClientAccessiblePermissionsReducer,
  getCustomerAccessiblePermissions: perm.GetCustomerAccessiblePermissionsReducer,
  deletePermission: perm.DeletePermissionsReducer,

  // user permissions
  userPermissions: userPerm.UserPermissionsReducer,
  allUserPermissions: userPerm.AllUserPermissionsReducer,
  assignPermission: userPerm.AssignPermissionReducer,
  assignBulkPermission: userPerm.AssignBulkPermissionReducer,
  revokePermission: userPerm.RevokePermissionReducer,
  revokeBulkPermission: userPerm.RevokeBulkPermissionReducer,
  unassignedPermissions: userPerm.UnassignedPermissionsReducer,
  unassignedClientPermissions: userPerm.UnassignedClientPermissionsReducer,

  fileUpload: files.FileUploadReducer,
  fileDelete: files.FileDeleteReducer,
  createDirectory: files.CreateDirectoryReducer,
  fileDownload: files.FileDownloadReducer,

  myAccount: accounts.MyAccountReducer,
  updateMyAccount: accounts.UpdateMyAccountReducer,

  mySmsSubscriptions: subscriptions.MySmsSubscriptionsReducer,
  myEmailSubscriptions: subscriptions.MyEmailSubscriptionsReducer,
  myActiveSmsSubscription: subscriptions.MyActiveSmsSubscriptionReducer,
  myActiveEmailSubscription: subscriptions.MyActiveEmailSubscriptionReducer,

  // Refill
  refillSmsCredits: subscriptions.RefillSmsCreditsReducer,
  refillEmailCredits: subscriptions.RefillEmailCreditsReducer,
  refillPricing: subscriptions.GetRefillPricingReducer,

  activateSmsTrial: trials.ActivateSmsTrialReducer,
  activateEmailTrial: trials.ActivateEmailTrialReducer,
  checkTrialEligibility: trials.CheckTrialEligibilityReducer,
  upgradeSmsSubscription: trials.UpgradeSmsSubscriptionReducer,
  upgradeEmailSubscription: trials.UpgradeEmailSubscriptionReducer,
  smsTrialInfo: trials.SmsTrialInfoReducer,
  emailTrialInfo: trials.EmailTrialInfoReducer,

  openEmailPackages: openPackages.OpenEmailPackagesReducer,
  openEmailPackagesFull: openPackages.OpenEmailPackagesFullReducer,
  openSmsPackages: openPackages.OpenSmsPackagesReducer,
  openSmsPackagesFull: openPackages.OpenSmsPackagesFullReducer,

  paySmsPackage: payments.PaySmsPackageReducer,
  payEmailPackage: payments.PayEmailPackageReducer,
  myTransactions: payments.MyTransactionsReducer,
  myTransactionDetails: payments.MyTransactionDetailsReducer,

  applicationMutation: applications.ApplicationMutationReducer,
  myApplications: applications.MyApplicationsReducer,
  allMyApplications: applications.AllMyApplicationsReducer,

  smsSend: sms.SmsSendReducer,
  mySms: sms.MySmsReducer,
  mySmsPaged: sms.MySmsPagedReducer,

  getAllAudits: audit.GetAllAuditsReducer,
  getUserAuditsByPeriod: audit.GetUserAuditsByPeriodReducer,
  getMyAuditsByPeriod: audit.GetMyAuditsByPeriodReducer,
  auditDetails: audit.AuditDetailsReducer,

  getESolutionsSmsAccount: esolutionsSmsAccount.GetESolutionsSmsAccountReducer,
  updateESolutionsSmsAccount: esolutionsSmsAccount.UpdateESolutionsSmsAccountReducer,

  createEmailPackage: emailPackage.CreateEmailPackageReducer,
  updateEmailPackage: emailPackage.UpdateEmailPackageReducer,
  deleteEmailPackage: emailPackage.DeleteEmailPackageReducer,
  getPagedEmailPackages: emailPackage.GetPagedEmailPackagesReducer,

  createSmsPackage: smsPackage.CreateSmsPackageReducer,
  updateSmsPackage: smsPackage.UpdateSmsPackageReducer,
  deleteSmsPackage: smsPackage.DeleteSmsPackageReducer,
  getPagedSmsPackages: smsPackage.GetPagedSmsPackagesReducer,
  getAllSmsPackages: smsPackage.GetAllSmsPackagesReducer,

  mailingLists: mailingList.MailingListReducer,    
  mailingListDetails: mailingList.MailingListDetailsReducer,
  mailingListCreate: mailingList.MailingListCreateReducer, 
  mailingListUpdate: mailingList.MailingListUpdateReducer,   
  mailingListDelete: mailingList.MailingListDeleteReducer,

  mailingEntries: mailingList.MailingEntryReducer,          
  mailingEntryCreate: mailingList.MailingEntryCreateReducer, 
  mailingEntryUpdate: mailingList.MailingEntryUpdateReducer, 
  mailingEntryDelete: mailingList.MailingEntryDeleteReducer,

  emailSend: email.EmailSendReducer,
  
  // Client email fetch reducers
  myEmails: email.MyEmailsReducer,
  myEmailsPaged: email.MyEmailsPagedReducer,
  
  // Admin email fetch reducers
  adminEmails: email.AdminEmailsReducer,
  adminEmailsPaged: email.AdminEmailsPagedReducer,
  
  // Statistics
  emailStatistics: email.EmailStatisticsReducer,

  //transactions
  getAllTransactions: transaction.GetAllTransactionsReducer,
  transactionDetails: transaction.TransactionDetailsReducer,
});




// get userInfo from localStorage
const userInfoFromStorage = localStorage.getItem('userInfo')
  ? JSON.parse(localStorage.getItem('userInfo'))
  : null;


const initialState = {
  userLogin: { userInfo: userInfoFromStorage },
};

export const store = configureStore({
  reducer: rootReducer,
  preloadedState: initialState,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }),
});
